import {ApiClientFactory, ApiClientFactoryInterface} from "./clients";
import {Headers} from "../types";
import {BorrowingOnboardingManager} from "../BorrowingOnboardingManager";

export class BorrowingOnboardingManagerFactory {
  private readonly apiClientFactory: ApiClientFactoryInterface;

  constructor(baseUrl: string, headers: Headers = {}) {
    this.apiClientFactory = new ApiClientFactory(
      `${baseUrl}/api/v1/borrower-onboarding`,
      headers
    );
  }

  createBorrowingOnboardingManager(token: string): BorrowingOnboardingManager {
    return new BorrowingOnboardingManager(this.apiClientFactory.createAuthorizedClient(token));
  }
    
}